import { slugify } from '@/common/utils'
import { HTMLAttributes } from 'react'

export function PageSection({
  heading,
  children,
  ...args
}: React.PropsWithChildren & HTMLAttributes<HTMLDivElement> & { heading?: string }) {
  const id = slugify(heading)
  const hasHeading = heading?.length

  return (
    <section aria-labelledby={id} {...args}>
      {hasHeading && (
        <h2 className="sr-only" id={id}>
          {heading}
        </h2>
      )}
      <div className="rounded-md bg-white dark:bg-gray-800 shadow-sm border dark:border-gray-700">
        {hasHeading && (
          <div className="p-4 py-2">
            <h3 className="font-medium leading-6 text-gray-900 dark:text-gray-200">{heading}</h3>
          </div>
        )}
        <div className={hasHeading ? 'border-t border-gray-200 dark:border-gray-600' : ''}>
          {children}
        </div>
      </div>
    </section>
  )
}
